import { gql } from "@apollo/client";

export default gql`
  mutation prepareFileUploadMutation(
    $filename: String!
    $contentType: String!
    $topicId: Int
    $artifactId: Int
    $recognitionCoreValueId: Int
    $organizationId: Int
  ) {
    prepareFileUpload(
      filename: $filename
      topicId: $topicId
      artifactId: $artifactId
      recognitionCoreValueId: $recognitionCoreValueId
      organizationId: $organizationId
      contentType: $contentType
    ) {
      fileUploadUrl
      fileViewingUrl
    }
  }
`;
